import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { AnalyticsService } from 'analytics';
import { Promotion } from 'interfaces';
import { OfferBoxComponent } from 'offer-box';
import { PCProduct } from 'product';
import { OfferBoxesSlice } from './offer-boxes.slice';

@Component({
  selector: 'app-offer-boxes',
  templateUrl: './offer-boxes.component.html',
  standalone: true,
  imports: [NgTemplateOutlet, NgClass, OfferBoxComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferBoxesComponent {
  private analytics = inject(AnalyticsService);
  @Input() slice: OfferBoxesSlice;

  get boxSize() {
    if (this.slice.displaySize === 'small-offer') {
      return 'small';
    }
    return 'medium';
  }

  onOfferClick({ product, promotion }: { product: PCProduct; promotion: Promotion }) {
    this.analytics.addECommerceEvent('add_to_cart', product, promotion);
  }
}
